import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GeneralModule } from '../general/general.module';
import { TranslateModule } from '@ngx-translate/core';
import { RefundCardStateService } from './services/refund-card-state.service';
import { CardRefundComponent } from './components/card-refund/card-refund.component';
import { SmartCardModule } from '../smart-card/smart-card.module';
import { LoginModule } from '../login/login.module';
import { RefundCardOrderService } from './services/refund-card-order.service';
import { RefundCardPartnerService } from './services/refund-card-partner.service';

const routes: Routes = [{
  path: 'card-refund',
  component: CardRefundComponent,
}];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    GeneralModule,
    SmartCardModule,
    LoginModule,
    RouterModule.forChild(routes),
  ],
  declarations: [
    CardRefundComponent
  ],
  providers: [
    RefundCardStateService,
    RefundCardOrderService,
    RefundCardPartnerService,
  ]
})
export class RefoundCardModule { }
